import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class GetIsSignedReportRequiredForAnnouncementInteractor {
  private applicantFormService: IApplicantFormService;

  constructor(applicantFormService) {
    this.applicantFormService = applicantFormService;
  }

  async execute() {
    return this.applicantFormService.isSignedReportRequiredForAnnouncement();
  }
}
